import { Redirect, Route, Switch } from 'react-router-dom';
import { $ImportIdRoutes } from './$importId/_config';
import UploadFile from './uploadFile';

export function ProductInternalIdRoutes({ match }) {
  return (
    <Switch>
      {/* The index route: */}
      <Redirect exact from={`${match.path}`} to={`${match.url}/uploadFile`} />

      <Route path={`${match.path}/uploadFile`} component={UploadFile} />
      <Route path={`${match.path}/:importId`} component={$ImportIdRoutes} />
    </Switch>
  );
}
